import React from "react";
import { Navigate } from "react-router-dom";
import * as LoginService from '../services/login.service';
import Cookies from 'js-cookie'

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      error: null,
      spin: false,
    }
  }

  componentDidMount() {
    //console.log(store);
    //let currEmail;
    // if (currEmail) {
    //   this.setState({
    //     user: null
    //   })
    // }
    let currEmail = localStorage.getItem('UserEmail');
    //console.log("CURR EMAIL");
    //console.log(currEmail);
    let cookie = Cookies.get('token')
    //setTimeout(() => {console.log("TIME")}, 5000)
    if (currEmail && cookie) {
      this.setState({
        user: currEmail
      })
    }
  }
  
  handleFormSubmit = (e) => {
    e.preventDefault();

    //begin spinner
    this.setState({ spin: true, error: null }); 

    if (this.state.error) {
      this.setState({
        error: null,
      });
    };
    let email = e.target.elements.email?.value;
    let password = e.target.elements.password?.value;
    //console.log(email)
    //console.log(password);
    if (email === ""){
      this.setState({
        error: "You Must Provide an Email"
      });
    } else if (password === "") {
      this.setState({
        error: "You Must Provide a Password"
      });
    } else {
      let data = {
        "email": email,
        "pass": password,
      } 

      LoginService.getLogin(data).then(response => {
        console.log(response);
        localStorage.setItem('UserEmail', email);
        let role = response.role;
        localStorage.setItem('Role', role);
        let token = Math.random().toString(36);
        //console.log(token);
        Cookies.set('token', token, {expires: 1/2})
        this.setState({
          user: email,
          role: role
        });
      }).catch(err => {
        
        console.log(err);
        this.setState({
          error: "Your Email/Password is Incorrect",
          spin: false
        })
      });
    }
    
    // let data = {
    //   "email": email,
    //   "pass": password,
    //   "role": "graphics"
    // } 
    // LoginService.saveLogin(data).then(response => {
    //   console.log(response);
    // }).catch(err => {
    //   console.log(err);
    // })

    // console.log("NAVIGATOR");

    //console.log(this.props.navigator);
    //console.log(this.props.navigator.navigate);

    //this.props.navigator.push("printverse")
    //navigate("../printverse", { replace: true });

    //this.navigate("../printverse", { replace: true });

    //console.log(email, password);

  };
  render() {
    return (
      <div className="h-screen flex bg-gray-800">
        
        
        {/* {(this.state.user && (this.state.role === 'admin')) && (
          //false
          <Navigate to="/printverse" replace={true} />
        )} */}
        {(this.state.user && this.state.role) && (
          //false
          <Navigate to="/openprint/orders" replace={true} />
        )}
        {(this.state.user && (this.state.role === 'ky prod')) && (
          //false
          <Navigate to="/kentuckyop" replace={true} />
        )}
        <div className='w-full max-w-md m-auto bg-white rounded-lg border border-primaryBorder shadow-default py-10 px-16'>
          {this.state.error && (
            <h3 className="text-red-500 text-xs italic">{this.state.error}</h3>
          )}
          <h1 className='text-2xl font-medium text-primary mt-4 mb-12 text-center'>
            PhotoUSA Admin Data Dashboard 🔐
          </h1>
          {this.state.spin && (
              <div className="flex justify-center my-4">
                <svg
                  role="status"
                  className="w-10 h-10 text-gray-800 animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
              </div>
            )}

          <form onSubmit={this.handleFormSubmit}>
            <div>
              <label htmlFor='email'>Email</label>
              <input
                type='email'
                id='email'
                className='w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4'
                placeholder='Email'
              />
            </div>
            <div>
              <label htmlFor='password'>Password</label>
              <input
                type='password'
                id='password'
                className='w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4'
                placeholder='Password'
              />
            </div>

            <div className='flex justify-center items-center mt-6'>
                <button
                    type="submit"
                    className='bg-gray-800 py-2 px-4 text-sm text-white rounded border border-green focus:outline-none focus:border-green-dark'
                    disabled={this.state.spin}
                  >
                    {this.state.spin ? 'Logging in...' : 'Login'}
                  </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Login;
